import styled from '@emotion/styled';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from './CardComponents'

import { useQuery } from '@tanstack/react-query';

// use pageData context
import { usePageData } from '../../contexts/PageData';


const GenericTab = () => {
  const { data = {} } = usePageData();

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Basic Details" />
          <CardContent>
            <CardBlockContainer>
          
        
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>

    </Grid>
  );

};

export default GenericTab;